import React from 'react';
import { IconButton } from '@telus-uds/components-web';
import EditIcon from '@telus-uds/palette-allium/build/web/icons/Edit';
import DeleteIcon from '@telus-uds/palette-allium/build/web/icons/Delete';
import PropTypes from 'prop-types';
import { Td, Th } from './css';

const ServiceDetailsTable = ({ offerDetails, editItem, deleteItem, setFieldValue, values }) => {
  if (!offerDetails || offerDetails.length === 0) return null;

  return (
    <div style={{ marginTop: '20px' }}>
      <h4>Added Service Details</h4>
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
          marginTop: '10px',
          border: '1px solid #ddd'
        }}
      >
        <thead>
          <tr>
            <Th>Offer Details (EN)</Th>
            <Th>Offer Details (FR)</Th>
            <Th>Value ($)</Th>
            <Th>Frequency</Th>
            <Th style={{ textAlign: 'center' }} colSpan={2}>
              Actions
            </Th>
          </tr>
        </thead>
        <tbody>
          {offerDetails.map((service, index) => (
            <tr key={service.id}>
              <Td>{service.offerDetailsEn}</Td>
              <Td>{service.offerDetailsFr}</Td>
              <Td>{service.value}</Td>
              <Td>{service.frequency}</Td>
              <Td style={{ textAlign: 'center' }}>
                <IconButton
                  icon={EditIcon}
                  onPress={() => editItem(values.offerDetails[index], setFieldValue)}
                  accessibilityLabel="Edit"
                />
              </Td>
              <Td style={{ textAlign: 'center' }}>
                <IconButton
                  icon={DeleteIcon}
                  onPress={e => deleteItem(e, index, values.offerDetails, setFieldValue)}
                  accessibilityLabel="Delete"
                />
              </Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

ServiceDetailsTable.propTypes = {
  offerDetails: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      offerDetailsEn: PropTypes.string,
      offerDetailsFr: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      frequency: PropTypes.string
    })
  ),
  editItem: PropTypes.func.isRequired,
  deleteItem: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.shape({
    offerDetails: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        offerDetailsEn: PropTypes.string,
        offerDetailsFr: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        frequency: PropTypes.string
      })
    )
  }).isRequired
};

export default ServiceDetailsTable;
